import {
  resolveRegistroStatoUi,
  registroStatoUiLabel,
  registroErrorDetail,
  type RegistroRow,
  type RegistroStatoUi,
} from "@/lib/registro";
import { Badge } from "@/components/ui/badge";

export function RegistroStatoBadge({ registro }: { registro: RegistroRow }) {
  const stato = resolveRegistroStatoUi(registro);
  const label = registroStatoUiLabel(stato);
  const error = registroErrorDetail(registro);

  let title = label;
  if (stato === "errore" && error) {
    title = `Errore: ${error}`;
  } else if (stato === "bozza") {
    title = "Registro non ancora inviato a RENTRI";
  } else if (stato === "in_elaborazione") {
    title = "Apertura in corso o in attesa di esito da RENTRI";
  } else if (stato === "attivo") {
    title = "Registro aperto su RENTRI";
  } else if (stato === "chiuso") {
    title = "Registro chiuso su RENTRI";
  }

  return (
    <Badge variant={variantFor(stato)} title={title} className="whitespace-nowrap">
      {stato === "in_elaborazione" && (
        <span
          aria-hidden
          className="mr-1 inline-block h-2 w-2 animate-pulse rounded-full bg-current opacity-70"
        />
      )}
      {label}
    </Badge>
  );
}

function variantFor(
  s: RegistroStatoUi,
): "default" | "secondary" | "outline" | "destructive" | "success" | "warning" {
  switch (s) {
    case "attivo":
      return "success";
    case "in_elaborazione":
      return "warning";
    case "errore":
      return "destructive";
    case "chiuso":
      return "secondary";
    case "bozza":
    default:
      return "outline";
  }
}
